<template>
  <div id="smsConfirmWrap">
    <p>Введите код из смс, отправленного на ваш номер телефона<span v-if="fieldName === 'SmsConfCode'">: {{phoneView}}</span></p>
    <div class="instInputWrap">
      <div class="instInputPosition">
        <input type="tel" v-model.trim="value">
        <div id="fakeView" v-html="fakeView"></div>
      </div>
    </div>
    <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>


  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instSmsInput",
  data(){
    return {
      kiurl:'/admd/ki/' + window.session_id + '/' + window.tmpTestValue,
    }
  },
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapState({
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
    phoneView(){
      return this.valueVuex['PHONE'];
    },
    fakeView() {
      const valueStr = this.value.toString();
      const out = [
        valueStr[0] !== undefined ? '<div>' + valueStr[0] + '</div>' : '<div>' + '_' + '</div>',
        valueStr[1] !== undefined ? '<div>' + valueStr[1] + '</div>' : '<div>' + '_' + '</div>',
        valueStr[2] !== undefined ? '<div>' + valueStr[2] + '</div>' : '<div>' + '_' + '</div>',
        valueStr[3] !== undefined ? '<div>' + valueStr[3] + '</div>' : '<div>' + '_' + '</div>',
      ];
      return out.join('');
    },
    value: {
      get() {
        return this.valueVuex[this.fieldName];
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: value
        });
      }
    },
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
.instInputWrap{width: var(--font-size-166);margin: var(--font-size-37) auto}
input{color:transparent;padding: var(--font-size-20) var(--font-size-16);}
#fakeView{position: absolute;top: 0; left: 0; width: calc(100% - (var(--font-size-16)*2));padding: var(--font-size-20) var(--font-size-16);display: flex;justify-content: space-around;pointer-events: none;}

</style>